<template>
    <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-10 col-sm-10 mx-auto form p-1">
            <div v-if="payload" class="alert alert-success" role="alert">
                Дані успішно збережені!
            </div>
            <div v-if="error" class="alert alert-danger" role="alert">
                Помилка при збереженні даних
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="form-group">
                        <label>
                            <strong>Описание КРМ</strong>
                        </label>
                        <textarea
                            name="krm_description"
                            v-model="model.krm_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание АВР</strong>
                        </label>
                        <textarea
                            name="avr_description"
                            v-model="model.avr_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание я5000</strong>
                        </label>
                        <textarea
                            name="ya5000_description"
                            v-model="model.ya5000_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание ЩО-90</strong>
                        </label>
                        <textarea
                            name="sho90_description"
                            v-model="model.sho90_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание ЩО-125</strong>
                        </label>
                        <textarea
                            name="sho125_description"
                            v-model="model.sho125_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание "Плавні пуски"</strong>
                        </label>
                        <textarea
                            name="plavni_spusky_description"
                            v-model="model.plavni_spusky_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание "Клемні ряди"</strong>
                        </label>
                        <textarea
                            name="klemnyi_riad_description"
                            v-model="model.klemnyi_riad_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание "Калькулятор терміну окупності пристрою КРП"</strong>
                        </label>
                        <textarea
                            name="kalkulyator_description"
                            v-model="model.kalkulyator_description"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание "Сервіс підбору шин"</strong>
                        </label>
                        <textarea
                            name="kalkulyator_pidboru_shin"
                            v-model="model.kalkulyator_pidboru_shin"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание "Підбір жорсткої шини"</strong>
                        </label>
                        <textarea
                            name="kalkulyator_zhorstkoyi_shini"
                            v-model="model.kalkulyator_zhorstkoyi_shini"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>Описание "Підбір гнучкої шини"</strong>
                        </label>
                        <textarea
                            name="kalkulyator_gnuchkoyi_shini"
                            v-model="model.kalkulyator_gnuchkoyi_shini"
                            class="form-control"
                        >
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <button
                    type="submit"
                    class="btn btn-primary"
                    @click.prevent="update"
                >
                    Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import "bootstrap/dist/css/bootstrap.min.css"

export default {
    props: {
        model: {
            type: Object,
            required: false,
        }
    },
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
    },
    data() {
        return {
            errors: {},
            payload: false,
            error: false,
        }
    },
    methods: {
        update() {
            this.payload = false;
            this.error = false;
            axios.post(this.route('api.service_description.update'), this.model)
                .then((result) => {
                    this.payload = true;
                    window.scroll(0, 0);
                }).catch((error) => {
                    this.error = true;
                    window.scroll(0, 0);
                })
        },
    }
}
</script>

<style scoped>
.file .pi {
    font-size: 24px;
}
</style>
